export default __webpack_public_path__ + "static/media/logo.3228c260.png";